import { render, staticRenderFns } from "./BMW2022ChargingDisclosure2.vue?vue&type=template&id=5d52b6e1&"
import script from "./BMW2022ChargingDisclosure2.vue?vue&type=script&lang=js&"
export * from "./BMW2022ChargingDisclosure2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports